document.addEventListener('DOMContentLoaded', async () => {
    const $interestedForm = document.querySelector('.interested-form');
    const urlParams = new URLSearchParams(window.location.search);
    const eventname = urlParams.get('name');
    const eventid = urlParams.get('id');

    if ($interestedForm && eventname && eventid) {
        const $eventnameField = $interestedForm.querySelector('.eventname.hidden');
        const $eventidField = $interestedForm.querySelector('.eventid.hidden');

        if ($eventnameField && $eventidField) {
            const $eventnameInput = $eventnameField.querySelector('input');
            $eventnameInput.value = eventname;

            const $eventidInput = $eventidField.querySelector('input');
            $eventidInput.value = eventid;
        }

        // Insert event metadata through JS because the form is rendered through Umbraco Forms.
        const $formCaption = $interestedForm.querySelector('.umbraco-forms-caption');

        if ($formCaption) {
            const $metadataField = document.createElement('fieldset');
            $metadataField.classList.add('field', 'mb-5');

            const $title = document.createElement('h3');
            $title.classList.add('title', 'is-4');
            $title.textContent = eventname;
            $metadataField.appendChild($title);

            $formCaption.insertAdjacentElement('afterend', $metadataField);
        }
    }
});
